import { useScroll } from 'framer-motion';
import { Bar } from './ScrollProgress.styles';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return <Bar style={{ scaleX: scrollYProgress }} />;
};

export default ScrollProgress;
